import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../styles'
import Icon from '../../../components/icon/Icon'
import { Tab, Tabs, withStyles } from '@material-ui/core'
import iconsEnum from '../../../enums/iconsEnum'
import LabelTab from './LabelTab'
import TabPanel from './TabPanel'
import Account from './account/Account'
import Documents from './docs/Documents'
import { IntlShape, useIntl } from 'react-intl'
import { ContractsModel } from '../../../types/contracts/contractsModel'
import { useMediaQuery } from 'react-responsive'
import classNames from 'classnames'

const CustomTabs = withStyles((theme) => ({
	root: {
		minHeight: 0,
		borderBottom: `1px solid ${theme.palette.blue['10']}`,
		backgroundColor: 'white'
	},
	indicator: {
		backgroundColor: theme.palette.accessibility.main
	}
}))(Tabs)

const CustomTab = withStyles((theme) => (
	{
		root: {
			textTransform: 'none',
			minWidth: '50%',
			color: theme.palette.blue['50'],
			'&:hover': {
				color: theme.palette.accessibility.main,
				opacity: 1
			},
			'&$selected': {
				color: theme.palette.blue.main
			},
			'&:focus': {
				color: theme.palette.blue.main
			}
		},
		selected: {}
	}
))(Tab)

const useStyle = makeStyles((theme) => ({
		...styles(theme),
		subMenuContainer: {
			backgroundColor: 'white'
		},
		largeIcon: {
			marginRight: '5%',
			fill: theme.palette.blue.main
		},
		smallIcon: {
			fill: theme.palette.blue.main,
			marginBottom: 10
		},
		largeButton: {
			padding: '32px 0px',
			'& span': {
				flexDirection: 'row'
			}
		},
		smallButton: {
			padding: '24px 0px',
			flexDirection: 'column'
		}
	}
))

interface AcceptingProps {
	contract: ContractsModel,
	selectedTab: number
}

type ContractsSubmenuProps = AcceptingProps

const ContractsSubMenu: React.FC<ContractsSubmenuProps> = (
	{
		contract,
		selectedTab
	}
) => {
	const classes = useStyle()
	const intl: IntlShape = useIntl()
	const [value, setValue] = React.useState(selectedTab)
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const tab1: string = intl.formatMessage({ id: 'contracts.accountTab', defaultMessage: 'Votre relevé de compte', description: 'Account tab' })
	const tab2: string = intl.formatMessage({ id: 'contracts.docsTab', defaultMessage: 'Vos documents', description: 'Documents tab' })

	const subMenuClass = classNames(
		classes.subMenuContainer
	)

	const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
		setValue(newValue)
	}

	return (
		<div className={subMenuClass}>
			<CustomTabs value={value} onChange={handleChange}>
				<CustomTab
					label={<LabelTab label={tab1} isLargeScreen={isLargeScreen} />}
					icon={
						<Icon
							icon={iconsEnum.Rents}
							size={isLargeScreen ? 32 : 22}
							className={isLargeScreen ? classes.largeIcon : classes.smallIcon}
						/>
					}
					value={0}
					className={isLargeScreen ? classes.largeButton : classes.smallButton}
				/>
				<CustomTab
					label={<LabelTab label={tab2} isLargeScreen={isLargeScreen} />}
					icon={
						<Icon
							icon={iconsEnum.Contracts}
							size={isLargeScreen ? 32 : 22}
							className={isLargeScreen ? classes.largeIcon : classes.smallIcon}
						/>}
					value={1}
					className={isLargeScreen ? classes.largeButton : classes.smallButton}
				/>
			</CustomTabs>
			<TabPanel value={value} index={0}>
				<Account
					contract={contract}
					isLargeScreen={isLargeScreen}
				/>
			</TabPanel>
			<TabPanel value={value} index={1}>
				<Documents
					contract={contract}
					isLargeScreen={isLargeScreen}
				/>
			</TabPanel>
		</div>
	)
}
export default ContractsSubMenu